import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalConfirmacaoMensagemComponent } from './modal-confirmacao-mensagem.component';

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';

@NgModule({
  declarations: [ModalConfirmacaoMensagemComponent],
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  exports: [
    ModalConfirmacaoMensagemComponent
  ]
})
export class ModalConfirmacaoMensagemModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas);
  }
}
